<template>

<app-page v-if="is.loaded" :title="page.reset_title" :description="page.reset_description">

	<app-inner :row="true" :condensed="true">

		<app-text>

			<app-message :error="true" v-if="is.errored">

				{{ page.reset_message_error }}

			</app-message>

			<app-message :success="true" v-if="is.saved">

				{{ page.reset_message_success }}

			</app-message>

			<app-group v-if="!is.saved">

				<app-input-password note="Must be at least 8 characters and include at least one letter and one number." v-model="inputs.password" :errored="errored.password" :placeholder="page.reset_password_placeholder" />
				<app-input-password v-model="inputs.passwordConfirm" :errored="errored.password" :placeholder="page.reset_confirm_placeholder" />
				
			</app-group>

            <app-group :row="true" :center="true">

                <app-button v-if="!is.saved" :loading="is.submitting" theme="blue" :text="page.reset_button_save" v-on:click="onResetClick" />
                <app-button to="Home" v-if="is.saved" theme="blue" :text="page.reset_button_home" />

            </app-group>

		</app-text>

	</app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'
import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinPage, mixinForm],

	data: function() {

		return {
            stayAfterSave: true,
            inputs: {
				password: '',
				passwordConfirm: ''
			},
			rules: {
				password: {
					required: true,
					password: true,
					minlength: 8,
					match: 'passwordConfirm'
				},
				passwordConfirm: {
					required: true,
					password: true,
					minlength: 8,
					match: 'password'
				}
			}
		}

	},
	
	methods: {

		onResetClick: function() {

			this.save('login/reset', {
				key: this.$route.params.key,
				password: this.inputs.password,
				passwordConfirm: this.inputs.passwordConfirm
			})

		}

	}

}

</script>